/** Join truthy class names into a single className string. */
export const join = (...xs: (string | false | null | undefined)[]): string => xs.filter(Boolean).join(" ");
